/*
 * @Date: 2024-09-29 14:13:06
 * @LastEditors: Mipawn dongzhan@mipawn.com
 * @LastEditTime: 2024-09-30 19:02:19
 * @Author: Mipawn
 * @Description: fb 账号
 */

import { request } from '@/utils/request';

/** 获取fb 绑定信息 */
export const getFbBindInfo = () =>
  request({
    url: `/fblogin/initconfig?ua=${navigator.userAgent || navigator.vendor || (window as any).opera}`,
    method: 'GET'
  });

/** fb 账号绑定领奖 */
export const fbReward = params => {
  return request({
    url: '/fblogin/reward',
    method: 'POST',
    data: {
      ...params,
      ua: navigator.userAgent || navigator.vendor || (window as any).opera
    }
  });
};
